import Vue from "vue";

const ModalEventBus = new Vue();

export default ModalEventBus;
